"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentMenu = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const ui_1 = require("@jsonjoy.com/ui");
const Iconista_1 = require("@jsonjoy.com/ui/lib/icons/Iconista");
const ShareDocumentPane_1 = require("../chrome/ShareDocumentPane");
const share_1 = require("../util/share");
const Sidetip_1 = require("@jsonjoy.com/ui/lib/1-inline/Sidetip");
const FontStyleButton_1 = require("@jsonjoy.com/ui/lib/2-inline-block/FontStyleButton");
const downloadBlob_1 = require("@jsonjoy.com/collaborative-ui/lib/util/downloadBlob");
const slate_react_1 = require("slate-react");
const behavior_1 = require("../behavior");
const keys_1 = require("../util/keys");
const EditableWidthButton_1 = require("../chrome/EditableWidthButton");
const CustomStylesPanel_1 = require("../custom-style/CustomStylesPanel");
const file_text_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/file-text"));
const keyboard_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/keyboard"));
const palette_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/palette"));
const automatic_gearbox_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/automatic-gearbox"));
const light_1 = tslib_1.__importDefault(require("iconista/lib/react/ibm_32/light"));
const lamp_desk_1 = tslib_1.__importDefault(require("iconista/lib/react/lucide/lamp-desk"));
const restore_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/restore"));
const maximize_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/maximize"));
const minimize_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/minimize"));
const arrows_maximize_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/arrows-maximize"));
const typography_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/typography"));
const brush_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/brush"));
const list_columns_reverse_1 = tslib_1.__importDefault(require("iconista/lib/react/bootstrap/list-columns-reverse"));
const file_export_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/file-export"));
const device_floppy_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/device-floppy"));
const tools_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/tools"));
const code_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/code"));
const braces_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/braces"));
const align_left_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/align-left"));
const arrows_horizontal_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/arrows-horizontal"));
const share_alt_1 = tslib_1.__importDefault(require("iconista/lib/react/ant_outline/share-alt"));
const check_1 = tslib_1.__importDefault(require("iconista/lib/react/atlaskit/check"));
const link_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/link"));
const adjustments_1 = tslib_1.__importDefault(require("iconista/lib/react/tabler/adjustments"));
const documentIcon = () => React.createElement(file_text_1.default, { width: 16, height: 16 });
const KeyboardIcon = (props) => (React.createElement(keyboard_1.default, { width: 16, height: 16, ...props }));
const ThemeIcon = (props) => (React.createElement(palette_1.default, { width: 16, height: 16, ...props }));
const ThemeAutoIcon = (props) => (React.createElement(automatic_gearbox_1.default, { width: 16, height: 16, ...props }));
const ThemeLightIcon = (props) => (React.createElement(light_1.default, { width: 16, height: 16, fill: "currentColor", ...props }));
const ThemeDarkIcon = (props) => (React.createElement(lamp_desk_1.default, { width: 16, height: 16, ...props }));
const ThemeDefaultIcon = (props) => (React.createElement(restore_1.default, { width: 16, height: 16, ...props }));
const MaximizeIcon = (props) => (React.createElement(maximize_1.default, { width: 16, height: 16, ...props }));
const MinimizeIcon = (props) => (React.createElement(minimize_1.default, { width: 16, height: 16, ...props }));
const FullscreenIcon = (props) => (React.createElement(arrows_maximize_1.default, { width: 16, height: 16, ...props }));
const TypographyIcon = (props) => (React.createElement(typography_1.default, { width: 16, height: 16, ...props }));
const CustomStylesIcon = (props) => (React.createElement(brush_1.default, { width: 16, height: 16, ...props }));
const rtlMirrorClass = (0, nano_theme_1.rule)({
    d: 'inline-flex',
    ai: 'center',
    jc: 'center',
    '&:dir(rtl)': {
        transform: 'scaleX(-1)',
    },
});
const UndoIcon = () => (React.createElement("span", { className: rtlMirrorClass },
    React.createElement(Iconista_1.Iconista, { set: "lucide", icon: "undo", width: 16, height: 16 })));
const RedoIcon = () => (React.createElement("span", { className: rtlMirrorClass },
    React.createElement(Iconista_1.Iconista, { set: "lucide", icon: "redo", width: 16, height: 16 })));
const GoToIcon = (props) => (React.createElement(list_columns_reverse_1.default, { width: 16, height: 16, ...props }));
const ExportIcon = (props) => (React.createElement(file_export_1.default, { width: 16, height: 16, ...props }));
const SaveIcon = (props) => (React.createElement(device_floppy_1.default, { width: 16, height: 16, ...props }));
const DevelopersIcon = (props) => (React.createElement(tools_1.default, { width: 16, height: 16, ...props }));
const EmbedIcon = (props) => (React.createElement(code_1.default, { width: 16, height: 16, ...props }));
// const BugIcon = makeIcon({set: 'tabler', icon: 'bug', width: 16, height: 16});
const BracesIcon = (props) => (React.createElement(braces_1.default, { width: 16, height: 16, ...props }));
// const TerminalIcon = makeIcon({set: 'tabler', icon: 'terminal-2', width: 16, height: 16});
const PlainTextIcon = (props) => (React.createElement(align_left_1.default, { width: 16, height: 16, ...props }));
const WidthIcon = (props) => (React.createElement(arrows_horizontal_1.default, { width: 16, height: 16, ...props }));
const ShareIcon = (props) => (React.createElement(share_alt_1.default, { width: 16, height: 16, fill: "currentColor", ...props }));
const ShareCheckIcon = (props) => (React.createElement(check_1.default, { width: 16, height: 16, ...props }));
const CopyLinkIcon = (props) => (React.createElement(link_1.default, { width: 16, height: 16, ...props }));
const ShareOptionsIcon = (props) => (React.createElement(adjustments_1.default, { width: 16, height: 16, ...props }));
const SHARE_COPIED_RESET_MS = 2000;
const shareIconStackClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    w: '16px',
    h: '16px',
    ov: 'hidden',
    d: 'inline-flex',
});
const shareIconLayerClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    t: 0,
    l: 0,
    w: '16px',
    h: '16px',
    d: 'flex',
    ai: 'center',
    jc: 'center',
    trs: 'transform 150ms ease-in-out',
});
const ShareCopyAnimIcon = ({ copied }) => {
    const isCopied = copied.use();
    return (React.createElement("span", { className: shareIconStackClass },
        React.createElement("span", { className: shareIconLayerClass, style: { transform: isCopied ? 'translateY(100%)' : 'translateY(0%)' } },
            React.createElement(ShareIcon, null)),
        React.createElement("span", { className: shareIconLayerClass, style: { transform: isCopied ? 'translateY(0%)' : 'translateY(-100%)' } },
            React.createElement(ShareCheckIcon, null))));
};
class DocumentMenu {
    constructor(mutxt) {
        this.mutxt = mutxt;
        this.shareJustCopied = ui_1.rsync.val(false);
        this.shareCopyResetTimer = null;
        this.pulseShareCopied = () => {
            this.shareJustCopied.set(true);
            if (this.shareCopyResetTimer)
                clearTimeout(this.shareCopyResetTimer);
            this.shareCopyResetTimer = setTimeout(() => {
                this.shareCopyResetTimer = null;
                this.shareJustCopied.set(false);
            }, SHARE_COPIED_RESET_MS);
        };
        this.exec = (fn) => (event) => {
            event.preventDefault();
            const mutxt = this.mutxt;
            mutxt.omni.close();
            fn();
            slate_react_1.ReactEditor.focus(mutxt.editor);
            mutxt.setFocused(true);
            mutxt.sync(true);
        };
    }
    start() {
        return () => { };
    }
    buildHeaderToolbar(size) {
        const mutxt = this.mutxt;
        const toggleKeys = ['Primary', 'Shift', 'm'];
        const fullscreenKeys = ['Primary', 'Shift', 'f'];
        const activeFor = (mode) => ui_1.rsync.comp([mutxt.displayMode], ([m]) => m === mode);
        const option = (mode, name, icon, keys, text) => ({
            name,
            text,
            icon,
            keys: [(0, keys_1.formatKeys)(toggleKeys)],
            right: keys ? () => React.createElement(Sidetip_1.Sidetip, { small: true }, (0, keys_1.formatKeys)(keys)) : void 0,
            active: activeFor(mode),
            disabled: activeFor(mode),
            onSelect: () => {
                mutxt.omni.close();
                mutxt.setDisplayMode(mode);
            },
        });
        const children = [];
        if (size > 4) {
            children.push(this.itemUndo(), this.itemRedo(), { name: 'sep-undo', sep: true });
        }
        if (size > 2) {
            children.push({
                name: mutxt.displayMode.value === 'inline' ? 'Maximized' : 'Inline',
                text: 'display mode size view fullscreen maximize minimize fullwindow',
                split: size > 4 ? 'Display' : void 0,
                keys: [(0, keys_1.formatKeys)(toggleKeys)],
                icon: () => (mutxt.displayMode.value === 'inline' ? React.createElement(MaximizeIcon, null) : React.createElement(MinimizeIcon, null)),
                onSelect: () => {
                    mutxt.omni.close();
                    mutxt.setDisplayMode(mutxt.displayMode.value === 'inline' ? 'fullwindow' : 'inline');
                },
                noHeader: true,
                children: size > 1
                    ? [
                        option('inline', 'Inline', () => React.createElement(MinimizeIcon, null), toggleKeys, 'embedded small minimize compact'),
                        option('fullwindow', 'Maximized', () => React.createElement(MaximizeIcon, null), toggleKeys, 'fullwindow maximize expand large full window'),
                        option('fullscreen', 'Fullscreen', () => React.createElement(FullscreenIcon, null), fullscreenKeys, 'full screen presentation'),
                    ]
                    : void 0,
            });
        }
        if (size > 0) {
            children.push(this.itemHeaderShare(size > 3));
        }
        children.push(this.build());
        return {
            name: 'Document menu',
            children,
        };
    }
    build() {
        return {
            name: 'Document',
            minWidth: 288,
            noHeader: true,
            icon: documentIcon,
            children: [
                this.itemTypesetting(),
                this.itemCustomStyles(),
                this.itemEditableWidth(),
                { name: 'sep-export', sep: true },
                this.menuExport(),
                this.shareMenu(),
                { name: 'sep-display', sep: true },
                this.itemDisplayMode(),
                this.mutxt.translit.menu.build(),
                this.itemKeyboardShortcuts(),
                this.itemTheme(),
                { name: 'sep-nav', sep: true },
                this.menuNavigate(),
                { name: 'sep-devs', sep: true },
                this.menuDevelopers(),
            ],
        };
    }
    itemTheme() {
        return {
            name: 'Theme',
            text: 'appearance color mode look palette skin',
            // sepBefore: true,
            // expand: 0,
            openOnTitleHov: true,
            icon: () => React.createElement(ThemeIcon, null),
            onSelect: () => { },
            children: [
                this.itemThemeOption(undefined, 'Default', () => React.createElement(ThemeDefaultIcon, null), 'reset original system'),
                this.itemThemeOption('auto', 'Auto', () => React.createElement(ThemeAutoIcon, null), 'system automatic os'),
                this.itemThemeOption('light', 'Light', () => React.createElement(ThemeLightIcon, null), 'white bright day'),
                this.itemThemeOption('dark', 'Dark', () => React.createElement(ThemeDarkIcon, null), 'night black'),
            ],
        };
    }
    itemThemeOption(value, name, icon, text) {
        const mutxt = this.mutxt;
        return {
            name,
            text,
            icon,
            active: ui_1.rsync.comp([mutxt.theme], ([t]) => t === value),
            onSelect: () => {
                mutxt.omni.close();
                mutxt.setTheme(value);
            },
        };
    }
    outlineItems() {
        const mutxt = this.mutxt;
        const outline = mutxt.outline();
        return outline.map((item) => ({
            id: item.key,
            name: item.title,
            display: () => (React.createElement("div", { style: {
                    paddingInlineStart: (item.level - 1) * 16,
                    fontWeight: 400 + (3 - item.level) * 100,
                    fontSize: item.level ? void 0 : '1.1em',
                } }, item.title)),
            icon: () => item.level ? (React.createElement(Iconista_1.Iconista, { set: "tabler", icon: `h-${item.level}`, width: 16, height: 16, style: { opacity: 0.5 } })) : (React.createElement(Iconista_1.Iconista, { set: "lucide", icon: "type", width: 16, height: 16, style: { opacity: 0.5 } })),
            onSelect: () => {
                mutxt.omni.close();
                mutxt.api.navigateTo(item.path);
            },
        }));
    }
    menuNavigate() {
        return {
            name: 'Navigate',
            text: 'jump scroll move find go',
            expand: 5,
            children: [this.itemGoTo(), { name: 'sep-history', sep: true }, this.itemUndo(), this.itemRedo()],
        };
    }
    itemGoTo() {
        const items = this.outlineItems();
        return {
            name: 'Go to',
            text: 'jump navigate heading outline section',
            icon: () => React.createElement(GoToIcon, null),
            minWidth: Math.min(320, (typeof window !== 'undefined' ? window.innerWidth : 320) - 32),
            children: items.length
                ? items
                : [
                    {
                        name: 'No headings',
                        disabled: ui_1.rsync.comp([], () => true),
                    },
                ],
        };
    }
    itemUndo() {
        const mutxt = this.mutxt;
        const keys = ['Primary', 'z'];
        const formatted = (0, keys_1.formatKeys)(keys);
        return {
            name: 'Undo',
            text: 'back revert reverse history step back',
            icon: () => React.createElement(UndoIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, formatted),
            keys: [formatted],
            disabled: ui_1.rsync.comp([mutxt.version, mutxt.readOnly], () => mutxt.readOnly.value || !(0, behavior_1.canUndo)(mutxt.editor)),
            onSelect: this.exec(() => (0, behavior_1.undo)(mutxt.editor)),
        };
    }
    itemRedo() {
        const mutxt = this.mutxt;
        const keys = ['Primary', 'Shift', 'z'];
        const formatted = (0, keys_1.formatKeys)(keys);
        return {
            name: 'Redo',
            text: 'forward repeat history step forward reapply',
            icon: () => React.createElement(RedoIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, formatted),
            keys: [formatted],
            disabled: ui_1.rsync.comp([mutxt.version, mutxt.readOnly], () => mutxt.readOnly.value || !(0, behavior_1.canRedo)(mutxt.editor)),
            onSelect: this.exec(() => (0, behavior_1.redo)(mutxt.editor)),
        };
    }
    itemTypesetting() {
        return {
            name: 'Typesetting',
            text: 'font face family typography typeface document',
            expand: 4,
            openOnTitleHov: true,
            icon: () => React.createElement(TypographyIcon, null),
            onSelect: () => { },
            children: [
                this.itemFontOption('sans', 'Sans-serif', 'sans gothic grotesque modern'),
                this.itemFontOption('serif', 'Serif', 'serif traditional roman'),
                this.itemFontOption('slab', 'Slab', 'slab egyptian thick serif'),
                this.itemFontOption('mono', 'Monospace', 'mono fixed code typewriter courier'),
            ],
        };
    }
    itemCustomStyles() {
        const mutxt = this.mutxt;
        const OverrideCount = () => {
            const cs = mutxt.customStyle.cs.use();
            const n = Object.keys(cs).length;
            if (!n)
                return null;
            return React.createElement(Sidetip_1.Sidetip, { small: true }, `${n} ${n === 1 ? 'style' : 'styles'}`);
        };
        return {
            name: 'Custom Styles',
            text: 'custom style typography font size weight color background line height letter spacing',
            icon: () => React.createElement(CustomStylesIcon, null),
            right: () => React.createElement(OverrideCount, null),
            minWidth: 330,
            panel: () => React.createElement(CustomStylesPanel_1.CustomStylesPanel, null),
        };
    }
    itemEditableWidth() {
        return {
            name: 'Width',
            text: 'page column size narrow wide layout content area',
            sepBefore: true,
            expand: 3,
            openOnTitleHov: true,
            icon: () => React.createElement(WidthIcon, null),
            onSelect: () => { },
            children: [
                this.itemEditableWidthOption('narrow', 'narrow small thin tight'),
                this.itemEditableWidthOption('mid', 'mid medium middle default'),
                this.itemEditableWidthOption('wide', 'wide large broad full'),
            ],
        };
    }
    itemEditableWidthOption(kind, text) {
        const mutxt = this.mutxt;
        const onSelect = () => {
            mutxt.omni.close();
            mutxt.setEditableWidth(kind);
        };
        const Option = ({ size }) => {
            const current = mutxt.editableWidth.use();
            return React.createElement(EditableWidthButton_1.EditableWidthButton, { kind: kind, size: size, active: current === kind, onClick: onSelect });
        };
        return {
            name: EditableWidthButton_1.LABELS[kind],
            text,
            icon: () => React.createElement(Option, { size: 16 }),
            iconBig: () => React.createElement(Option, null),
            active: ui_1.rsync.comp([mutxt.editableWidth], ([w]) => w === kind),
            onSelect,
        };
    }
    itemFontOption(kind, name, text) {
        const mutxt = this.mutxt;
        const onSelect = () => {
            mutxt.omni.close();
            mutxt.setFont(kind);
        };
        const Option = ({ size }) => {
            const font = mutxt.font.use();
            return React.createElement(FontStyleButton_1.FontStyleButton, { kind: kind, size: size, active: font === kind, onClick: onSelect });
        };
        return {
            name,
            text,
            icon: () => React.createElement(Option, { size: 16 }),
            iconBig: () => React.createElement(Option, null),
            active: ui_1.rsync.comp([mutxt.font], ([f]) => f === kind),
            onSelect,
        };
    }
    itemKeyboardShortcuts() {
        const formatted = (0, keys_1.formatKeys)(['Primary', '/']);
        return {
            name: 'Keyboard shortcuts',
            text: 'hotkey hot key bindings cheatsheet help kbd shortcut',
            icon: () => React.createElement(KeyboardIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, formatted),
            keys: [formatted],
            onSelect: () => {
                this.mutxt.omni.close();
                this.mutxt.shortcutsOpen.set(true);
            },
        };
    }
    itemDisplayMode() {
        return {
            name: 'Display',
            text: 'mode size view layout fullscreen maximize minimize',
            icon: () => React.createElement(MaximizeIcon, null),
            children: [
                this.itemDisplayModeOption('inline', 'Inline', () => React.createElement(MinimizeIcon, null), undefined, 'embedded small minimize compact'),
                this.itemDisplayModeOption('fullwindow', 'Maximized', () => React.createElement(MaximizeIcon, null), ['Primary', 'Shift', 'm'], 'fullwindow maximize expand large full window'),
                this.itemDisplayModeOption('fullscreen', 'Fullscreen', () => React.createElement(FullscreenIcon, null), ['Primary', 'Shift', 'f'], 'full screen presentation'),
            ],
        };
    }
    itemDisplayModeOption(mode, name, icon, keys, text) {
        const mutxt = this.mutxt;
        const formatted = keys ? (0, keys_1.formatKeys)(keys) : void 0;
        return {
            name,
            text,
            icon,
            keys: formatted ? [formatted] : void 0,
            right: formatted ? () => React.createElement(Sidetip_1.Sidetip, { small: true }, formatted) : void 0,
            active: ui_1.rsync.comp([mutxt.displayMode], ([m]) => m === mode),
            onSelect: () => {
                mutxt.omni.close();
                mutxt.setDisplayMode(mode);
            },
        };
    }
    menuExport() {
        return {
            name: 'Export',
            text: 'download save file output',
            icon: () => React.createElement(ExportIcon, null),
            children: [this.itemSaveFile()],
        };
    }
    shareMenu() {
        return {
            name: 'Share',
            text: 'send link copy publish collaborate invite',
            icon: () => React.createElement(ShareIcon, null),
            children: [this.itemCopyShareLink(), this.itemShareOptions()],
        };
    }
    itemHeaderShare(split) {
        return {
            name: 'Share',
            text: 'send link copy publish collaborate invite',
            icon: () => React.createElement(ShareCopyAnimIcon, { copied: this.shareJustCopied }),
            noHeader: true,
            onSelect: () => {
                const mutxt = this.mutxt;
                mutxt.omni.close();
                (0, share_1.copyDefaultShareLink)(mutxt.api.toBinary())
                    .then(() => {
                    this.pulseShareCopied();
                    mutxt.toasts?.add({ title: 'Share link copied to clipboard.', duration: 3000 });
                })
                    .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error('[mutxt] copy share link failed', err);
                    mutxt.toasts?.add({ type: 'error', title: 'Failed to copy share link.', duration: 5000 });
                });
            },
            split: split ? 'Share' : void 0,
            minWidth: split ? 380 : void 0,
            maxWidth: split ? 380 : void 0,
            children: split
                ? [
                    {
                        name: 'share-form',
                        raw: () => React.createElement(ShareDocumentPane_1.ShareDocumentForm, null),
                    },
                ]
                : void 0,
        };
    }
    itemCopyShareLink() {
        return {
            name: 'Copy share link',
            text: 'url clipboard share send link copy',
            icon: () => React.createElement(CopyLinkIcon, null),
            onSelect: () => {
                const mutxt = this.mutxt;
                mutxt.omni.close();
                const bytes = mutxt.api.toBinary();
                (0, share_1.copyDefaultShareLink)(bytes)
                    .then(() => {
                    mutxt.toasts?.add({ title: 'Share link copied to clipboard.', duration: 3000 });
                })
                    .catch((err) => {
                    // eslint-disable-next-line no-console
                    console.error('[mutxt] copy share link failed', err);
                    mutxt.toasts?.add({ type: 'error', title: 'Failed to copy share link.', duration: 5000 });
                });
            },
        };
    }
    itemShareOptions() {
        return {
            name: 'Sharing options',
            text: 'share settings encryption metadata posts publish collaborators',
            more: true,
            icon: () => React.createElement(ShareOptionsIcon, null),
            minWidth: 480,
            maxWidth: 480,
            children: [
                {
                    name: 'share-form',
                    raw: () => React.createElement(ShareDocumentPane_1.ShareDocumentForm, null),
                },
            ],
        };
    }
    itemSaveFile() {
        return {
            name: 'Save file',
            text: 'download export mutxt binary backup',
            icon: () => React.createElement(SaveIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, '.mutxt'),
            onSelect: () => {
                const mutxt = this.mutxt;
                mutxt.omni.close();
                const data = mutxt.api.toBinary();
                const blob = new Blob([data], { type: 'application/octet-stream' });
                (0, downloadBlob_1.downloadBlob)(blob, 'document.mutxt');
            },
        };
    }
    menuDevelopers() {
        return {
            name: 'Developers',
            text: 'debug dev tools developer advanced',
            icon: () => React.createElement(DevelopersIcon, null),
            children: [
                this.itemEmbedDocs(),
                { name: 'sep-dev-dumps', sep: true },
                this.itemPeritextDump(),
                this.itemModelDump(),
                this.itemSlateState(),
                this.itemPlainText(),
            ],
        };
    }
    itemEmbedDocs() {
        return {
            name: 'Embed this editor',
            text: 'embed integrate install npm cdn html react component custom element web mutxt',
            icon: () => React.createElement(EmbedIcon, null),
            onSelect: () => {
                this.mutxt.omni.close();
                this.mutxt.embedDocsOpen.set(true);
            },
        };
    }
    itemPeritextDump() {
        return {
            name: 'Peritext dump',
            text: 'peritext debug export crdt internal text representation',
            // icon: () => <TerminalIcon />,
            icon: () => React.createElement(PlainTextIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, '.txt'),
            onSelect: () => {
                const mutxt = this.mutxt;
                mutxt.omni.close();
                const peritext = mutxt.peritextRef().peritext();
                peritext.refresh();
                const text = peritext + '';
                const blob = new Blob([text], { type: 'text/plain' });
                (0, downloadBlob_1.downloadBlob)(blob, 'peritext.txt');
            },
        };
    }
    itemModelDump() {
        return {
            name: 'JSON CRDT dump',
            text: 'crdt model json debug export internal',
            // icon: () => <TerminalIcon />,
            icon: () => React.createElement(PlainTextIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, '.txt'),
            onSelect: () => {
                const mutxt = this.mutxt;
                mutxt.omni.close();
                const text = mutxt.obj.api.model + '';
                const blob = new Blob([text], { type: 'text/plain' });
                (0, downloadBlob_1.downloadBlob)(blob, 'crdt-model.txt');
            },
        };
    }
    itemSlateState() {
        return {
            name: 'Editor state',
            text: 'slate json debug export tree internal nodes',
            icon: () => React.createElement(BracesIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, '.json'),
            onSelect: () => {
                const mutxt = this.mutxt;
                mutxt.omni.close();
                const text = JSON.stringify(mutxt.editor.children, null, 2);
                const blob = new Blob([text], { type: 'application/json' });
                (0, downloadBlob_1.downloadBlob)(blob, 'editor-state.json');
            },
        };
    }
    itemPlainText() {
        return {
            name: 'Plain text',
            text: 'txt unformatted raw export download text',
            icon: () => React.createElement(PlainTextIcon, null),
            right: () => React.createElement(Sidetip_1.Sidetip, { small: true }, '.txt'),
            onSelect: () => {
                const mutxt = this.mutxt;
                mutxt.omni.close();
                const text = mutxt.peritextRef().peritext().strApi().view();
                const blob = new Blob([text], { type: 'text/plain' });
                (0, downloadBlob_1.downloadBlob)(blob, 'document.txt');
            },
        };
    }
}
exports.DocumentMenu = DocumentMenu;
